export const ADMIN_PERMISSIONS = {
  upload: [],
  sourceInputs: ["admin"],
  snapshotBulk: ["snapshot-upload", "admin"],
  snapshotConfig: ["admin"],
  snapshotOrders: ["snapshot-orders", "admin"],
  salesPerformance: ["sales:read"],
  ordersAnalytics: ["orders:read", "analytics:orders", "admin"],
  shareTemplates: ["admin", "university-admin", "social-media"],
  analytics: ["admin", "analytics-viewer", "analytics_viewer"],
  imports: ["admin", "import:read", "import:write"],
  importsWrite: ["admin", "import:write"],
  clipsExplorer: ["admin", "university-admin", "analytics-viewer", "analytics_viewer"],
  customerOperations: ["admin", "support:read", "support:delivery"],
  uploadNotifications: ["admin", "university-admin"],
  semanticCeremonySearch: ["admin", "semantic-search"],
  userManagement: ["admin"],
  supportReview: ["mgc-gmail-support"],
};

export function hasAnyRole(roles, required) {
  if (!Array.isArray(required) || required.length === 0) return true;
  const roleSet = new Set(Array.isArray(roles) ? roles : []);
  return required.some((r) => roleSet.has(r));
}

export function canAccess(roles, permissionKey) {
  if (permissionKey === "salesPerformance" && Array.isArray(roles) && roles.includes("university-admin")) return false;
  const required = ADMIN_PERMISSIONS[permissionKey] || [];
  return hasAnyRole(roles, required);
}
